<template>
  <div class="container">
    
    <ul class="blog-list">
        <!-- 博客文章 1 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/rollercover.webp" alt="滚动币">
            </div>
            <div class="blog-content">
                <h2 class="blog-title">
                  <router-link to="/blog/rollercoin">rollercoin 新手攻略</router-link>
                  <!-- <a href=""></a> -->
                </h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月5日</span>
                    <span>分类：链游挖矿</span>
                </div>
                <p class="blog-excerpt">RollerCoin 是一款挖矿游戏，它的目的是让你在游戏中获得乐趣，并以真实的加密货币获得奖励。</p>
                <router-link to="/blog/rollercoin" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 博客文章 2 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/sunflowercover.webp" alt="sunflower land">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/sunflowerland">sunflower land 新手攻略</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月1日</span>
                    <span>分类：链游</span>
                </div>
                <p class="blog-excerpt">
                    在向日葵乐园种植、制作并赚钱——唯一由社区控制代币、NFT 和资源的区块链游戏。
                </p>
                <router-link to="/blog/sunflowerland" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 博客文章 3 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/picover.webp" alt="pinetwork">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/pinetwork">Pi Network从手机挖矿到AI算力网络的进化之路</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年2月20日</span>
                    <span>分类：技术趋势</span>
                </div>
                <p class="blog-excerpt">
                    Pi Network 是一个于 2019 年发起的加密货币项目，其最大特点是用户可以通过手机 App 进行“挖矿”，而无需消耗大量计算能力和电力。
                </p>
                <router-link to="/blog/pinetwork" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 博客文章 4 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/web3cover.webp" alt="web3">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/web3">WEB3发展趋势</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年2月10日</span>
                    <span>分类：技术趋势</span>
                </div>
                <p class="blog-excerpt">
                    Web3的发展已经超越了早期的加密货币叙事，进入了一个以实用性、合规性与技术融合为核心的新阶段。行业焦点正从“构建加密原生应用”转向“利用加密技术解决现实世界问题”，并深度融入主流商业和金融体系。
                </p>
                <router-link to="/blog/web3" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 文章5 -->
         <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/ailicai.webp" alt="web3">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/intelligence">AI与理财的碰撞</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月10日</span>
                    <span>分类：趋势分析</span>
                </div>
                <p class="blog-excerpt">
                    AI与理财的碰撞，正从简单的“信息查询”进化为深刻的“服务重构”。这场碰撞不仅是技术的升级，更是理财服务模式、风险格局和行业生态的全面重塑。我们正见证着理财服务从“专家专属”走向“大众普惠”，从“被动响应”走向“主动规划”。
                </p>
                <router-link to="/blog/intelligence" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 文章6 -->
         <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/shuzi.webp" alt="web3">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/digital">数字资产未来会如何发展</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月15日</span>
                    <span>分类：趋势分析</span>
                </div>
                <p class="blog-excerpt">
                   数字资产（Digital Assets）正在经历从“投机代币”向“基础设施价值”的历史性跨越。随着 Web3.0、元宇宙和央行数字货币（CBDC）的兴起，数字资产不再仅仅是比特币或以太坊的价格波动，而是正在重塑全球金融体系、社会治理和个人数据主权的基石。
                </p>
                <router-link to="/blog/digital" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
    </ul>
    
  </div>
</template>

<script>
/**
 * 逻辑部分 (Script)
 * 定义组件的数据、方法、生命周期钩子等
 */
export default {
  name: 'MyBlog', // 组件名称，用于调试和递归组件
  data() {
    // data 必须是一个函数，以避免多个实例间的数据共享
    return {
      title: '实现被动收入，迈向财富自由',
      showMessage: true,
      
    }
  },
  methods: {
    // 定义事件处理函数
    updateTitle(newTitle) {
      this.title = newTitle;
    }
  },
  mounted() {
    // 组件挂载到 DOM 后执行
    console.log('组件已挂载');
  }
}
</script>

<style scoped>
/**
 * 样式部分 (Style)
 * scoped 属性确保样式仅作用于当前组件，避免全局污染
 */
.container {
    padding: 20px;
    background-color: #2f3045;
    max-width: 1200px;
    margin: 20px auto;
    width: 100%;
    box-sizing: border-box;
}

.blog-list {
    list-style: none;
}

.blog-item {
    display: flex;
    padding: 25px 0;
    border-bottom: 1px solid #eee;
    transition: transform 0.2s ease;
    gap: 25px;
}

.blog-item:hover {
    transform: translateY(-2px);
}

.blog-item:last-child {
    border-bottom: none;
}

.blog-cover {
    flex: 0 0 200px;
    height: 150px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    flex-shrink: 0;
}



.blog-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.blog-item:hover .blog-cover img {
    transform: scale(1.05);
}

.blog-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.blog-title {
    font-size: 24px;
    margin-bottom: 10px;
    color: #fff;
    text-decoration: none;
    display: inline-block;
    transition: color 0.2s ease;
}

.blog-title:hover {
    color: #3498db;
}

.blog-meta {
    display: flex;
    gap: 15px;
    font-size: 14px;
    margin-bottom: 15px;
    color: #03e1e4;
}

.blog-excerpt {
    color: #fff;
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 15px;
    flex-grow: 1;
}

.read-more {
    color: #3498db;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: gap 0.2s ease;
    align-self: flex-start;
    padding: 8px 16px;
    border: 1px solid #3498db;
    border-radius: 4px;
}

.read-more:hover {
    gap: 10px;
    background-color: #3498db;
    color: #fff;
}

@media (max-width: 768px){
    .blog-item{
        flex-direction: column;
    }
}


</style>